// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2RQ7F","content":"LoadingAlert_content__2zqBk"};